
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#666","cx":"8","cy":"8","r":"8"}}),_c('path',{attrs:{"d":"M10.263 4.606l1.131 1.131L9.131 8l2.263 2.263-1.131 1.131L8 9.131l-2.263 2.263-1.131-1.131L6.868 8 4.606 5.737l1.131-1.131L8 6.868l2.263-2.262z","fill":"#FFF"}})])])
          )
        }
      }
    